<template>
  <container
    subHeaderTitle="PASS프라임<br /><b>해지하기</b>"
    subHeaderText="가입자의 정보 확인이 꼭 필요합니다.<br />본인의 정보를 정확히 입력하시기 바랍니다."
    subHeaderAlign="center"
  >
    <section class="form-area mb-180">
      <v-container class="py-0">
        <v-row justify="center">
          <v-col cols="12" md="4" sm="6">
            <v-form v-model="valid" ref="form" onsubmit="return false;">
              <p>휴대폰번호</p>
              <div class="d-flex">
                <v-select
                  :items="items" 
                  item-text="text" 
                  item-value="value" 
                  v-model="teleCoCd" 
                  solo
                />
                <v-text-field
                  v-model="cellTelNo"
                  :rules="rules.cellTelNoRules"
                  label="'-'를 제외하고 입력"
                  mask="###########"
                  solo
                  maxlength="11"
                  @keyup="replaceNan('cellTelNo')"
                />
              </div>
              <p>이름</p>
              <v-text-field v-model="name" :rules="rules.nameRules" label="이름" solo />
              <p>생년월일</p>
              <v-text-field v-model="birth" :rules="rules.birthRules" label="19990101" mask="########" solo maxlength="8" @keyup="replaceNan('birth')"/>
              <p>성별</p>
              <v-btn-toggle color="primary" borderless mandatory v-model="genCd">
                <v-btn value="M">남</v-btn>
                <v-btn value="F">여</v-btn>
              </v-btn-toggle>
              <div class="recaptcha-area">
                <vue-recaptcha ref="recaptcha" v-model="recaptchaVerify" @verify="onVerify" @expired="onExpired" :sitekey="$cfg.recaptchaSiteKey"></vue-recaptcha>
                <div class="v-messages theme--light error--text mt-2">
                  <div class="v-messages__wrapper">
                    <div class="v-messages__message" v-if="!recaptchaVerifyCheck">로봇이 아닙니다를 체크해주세요</div>
                  </div>
                </div>
              </div>
              <div>
                <v-btn class="submit" rounded block large depressed color="primary" v-on:click="submit"
                :data-ga-category="gaEvent.category.support.prime.termi.name" :data-ga-label="gaEvent.category.support.prime.termi.label1" :data-ga-action="gaEvent.actions.buttonClick"
                >해지하기</v-btn>
              </div>
              <div class="text-center mt-3">
                <v-btn class="back" text rounded @click.stop="goBack"
                :data-ga-category="gaEvent.category.support.prime.termi.name" :data-ga-label="gaEvent.category.support.prime.termi.label2" :data-ga-action="gaEvent.actions.buttonClick"
                >취소</v-btn>
              </div>
            </v-form>
          </v-col>
        </v-row>
      </v-container>
    </section>
  </container>
</template>

<style lang="scss" scoped>
@import "~@/styles/cscenter";

/* validation check color red */
.v-messages__message {
  color: #ff5252 !important;
}
.v-messages__wrapper {
  color: #ff5252 !important;
}
.v-input__control,
.v-input__slot,
.v-select__slot {
  color: #005df9 !important;
}
.mdi-radiobox-marked {
  color: #005df9 !important;
}
</style>

<script>
import Container from "@/pages/container/index.vue";
import PassSafeguardTermination from "@/views/csCenter/PassSafeguardTermination";
import {GaTracking} from "@/mixins/index.js";

const TEST_MONTH_DAY = (v) => {
  if (!v || v.length !== 8 || Number.isNaN(v)) return false;
  const month = Number(v.substr(4,2))
  const day = Number(v.substr(6,2))

  // 1, 3, 5, 7, 8, 10, 12 (31)
  // 2 (29)
  // 4, 6, 9, 11 (30)
  return month === 2 ? day <= 29 : [4, 6, 9, 11].includes(month) ? day <= 30 : day<= 31;
}


export default {
  mixins: [PassSafeguardTermination, GaTracking],
  name: "PassPrimeTermination",
  components: {
    Container
  },
  data: () => ({
    items: [
      { text: 'SKT', value: '1' },
    ],
    valid: false,
    recaptchaVerify: false,
    recaptchaVerifyCheck: true,
    teleCoCd: "1", //통신사구분코드
    name: "", // 이름
    birth: "", // 생년월일
    genCd: "M", // 성별코드
    cellTelNo: "", // 전화번호
    rules: {
      nameRules: [v => !!v || "이름을 입력하세요."],
      birthRules: [
        v => !!v || "생년월일을 입력하세요.",
        v => (v && v.length >= 8 && /((1|2)[0-9]{3})(0[1-9]{1}|1[0-2]{1})(0[1-9]|(1|2)[0-9]{1}|3[0-1]{1})$/.test(v) && TEST_MONTH_DAY(v)) || "생년월일이 정확하지 않습니다."
      ],
      cellTelNoRules: [
        v => !!v || "휴대폰번호를 입력하세요.",
        v =>
            (v &&
                v.length >= 11 &&
                /(01[0])([1-9]{1}[0-9]{2,3})([0-9]{4})$/.test(v)) ||
            "휴대폰번호가 정확하지 않습니다."
      ]
    }
  }),
  methods: {
    submit(e) {
      this.gaTracking(e);
      this.recaptchaVerifyCheck = this.recaptchaVerify;
      this.$refs.form.validate();
      //   console.log("this.valid", this.valid);
      if (!this.valid) {
        return false;
      }
      if (!this.recaptchaVerify) {
        return false;
      }

      this.$router.push({
        name: "PassPrimeCert",
        params: {
          type: "termination",
          teleCoCd: this.teleCoCd,
          cellTelNo: this.cellTelNo,
          name: this.name,
          birth: this.birth,
          genCd: this.genCd,
          chanCd: this.$route.name === "PassPrimeSmsTermination" ?  "C102" : "F100"
        }
      });
    },
    //vue-recaptcha
    onVerify(r) {
      // console.log(r);
      this.recaptchaVerify = true;
      this.recaptchaVerifyCheck = this.recaptchaVerify
    },
    onExpired() {
      this.$refs.recaptcha.reset();
    },
    exec() {
      this.$refs.recaptcha.execute();
    },
    reset() {
      this.$refs.recaptcha.reset();
    },
    goBack(e) {
      this.gaTracking(e);
      // this.$router.push({ name: 'Support' });
    }
  }
};
</script>
